import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function BlogPage() {
  return <div className="min-h-screen bg-weiss flex flex-col" data-id="element-233">
      <Navigation data-id="element-234" />
      <main className="flex-grow flex items-center justify-center pt-32 pb-16" data-id="element-235">
        <h1 className="text-5xl md:text-7xl font-poppins font-bold text-schwarz uppercase tracking-tight" data-id="element-236">
          Blog
        </h1>
      </main>
      <Footer data-id="element-237" />
    </div>;
}